<template>
    <div>
        <el-form :inline="true" size="mini" class="demo-form-inline" label-width="120px" ref="wrongForm" :model="wrongForm">
           <el-form-item label="报关人员">
                <el-input v-model="wrongForm.createUser" clearable  placeholder="请输入报关人员"></el-input>
            </el-form-item>
            <el-form-item label="驳回信息">
                <el-input v-model="wrongForm.wrongInfo" clearable  placeholder="请输入报关错误信息"></el-input>
            </el-form-item>
            <!-- <el-form-item label="记录时间">
                 <el-date-picker clearable v-model="wrongForm.createTime" type="date" value-format="yyyy-MM-dd" placeholder="选择记录时间"></el-date-picker>
            </el-form-item> -->
            <el-form-item label="记录时间" >
                <el-date-picker clearable v-model="wrongData" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                 end-placeholder="结束日期" unlink-panels :picker-options="pickerOptions" @change="getData" >
                </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="驳回人员">
                <el-input v-model="wrongForm.rejectPerson" clearable  placeholder="请输入驳回人员"></el-input>
            </el-form-item>
            <el-form-item label="合同协议号">
                <el-input v-model="wrongForm.contrNo" clearable  placeholder="请输入合同协议号"></el-input>
            </el-form-item>
            <el-form-item label="提运单号">
                <el-input v-model="wrongForm.billNo" clearable  placeholder="请输入提运单号"></el-input>
            </el-form-item>
            <el-form-item label="报关单号">
                <el-input v-model="wrongForm.entryNo" clearable  placeholder="请输入报关单号"></el-input>
            </el-form-item> -->
            <el-form-item label=" " label-width="0" >
                <el-button size="mini" type="primary" plain round @click="getWrongList">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="wrongList" style="width: 100%" size="mini":header-cell-style="{'text-align':'center','background':'#f8f8f9'}">
            <el-table-column type="index" width="100"> </el-table-column>
            <el-table-column label="报关人员" property="createUser" align="center" width="100"> </el-table-column>
            <el-table-column label="记录时间" property="createTime" align="center" width="200"> </el-table-column>
            <el-table-column label="合同协议号" property="contrNo" align="center" width="200"> </el-table-column>
            <el-table-column label="提运单号" property="billNo" align="center" width="200"> </el-table-column>
            <el-table-column label="报关单号" property="entryNo" align="center" width="200"> </el-table-column>
            <el-table-column label="驳回人员" property="rejectPerson" align="center" width="200"> </el-table-column>
            <el-table-column label="驳回信息" property="wrongInfo" align="center"> </el-table-column>
        </el-table>
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'

export default {
    name: 'insWrongRecord',
    components:{
        
    },
    data() {
        return {
            wrongList:[],
            wrongForm:{
                createTime:'', // 记录时间
                createUser:'', // 报关人员
                wrongInfo:'', // 报关错误信息
                startTime:'', // 开始时间
                endTime:'', // 结束时间
                contrNo:'', // 合同协议号
                billNo:'', // 提运单号
                entryNo:'', // 报关单号
                rejectPerson:'', // 驳回人员
            },
            wrongData:[],
            pickerOptions: {
                shortcuts: [{
                    text: '当天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    mounted() {
        this.getWrongList()
    },
    methods: {
        getWrongList(){
            this.$api.getWrongRecord(this.wrongForm).then(res =>{
                this.wrongList = res
            })
            
        },
        getData(value){
            if(value){
                this.wrongForm.startTime = value[0]
                this.wrongForm.endTime = value[1]
            }else{
                this.wrongForm.startTime = ''
                this.wrongForm.endTime = ''
            }
        },
    }
}
</script>
<style lang="css" scoped>
.el-table {
    margin-top: 0px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px !important;
}
.el-form{
    background-color: white;
    padding-bottom: 5px;
}
</style>